import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { KnBrCartQuoteSummaryModule } from './kn-br-cart-quote-summary/kn-br-cart-quote-summary.module';
import { KnBrCustomerSearchModule } from './kn-br-customer-search/kn-br-customer-search.module';
import { KnBrRecentCustomerResultModule } from './kn-br-recent-customer-result/kn-br-recent-customer-result.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@spartacus/core';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrCustomerContextGuard } from '../shared/guards/kn-br-customer-context.guard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KnBrCustomerSearchModule,
    KnBrCartQuoteSummaryModule,
    KnBrRecentCustomerResultModule,
    RouterModule.forChild([
      {
        data: { pageLabel: 'sales', cxRoute: 'home' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard, KnBrCustomerContextGuard],
        component: PageLayoutComponent,
      },
    ]),
  ],
})
export class KnBrHomeModule {}
